import { zSidLabel } from "src/types";
import z from "zod";

export const zRoleAccess = z.object({
  role: zSidLabel,
  canRead: z.boolean().nullish(),
  canCreate: z.boolean().nullish(),
  canUpdate: z.boolean().nullish(),
  canDelete: z.boolean().nullish(),
});

export type ZRoleAccess = z.infer<typeof zRoleAccess>;
